import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CreateCompanyComponent } from 'app/dialogs/create-company/create-company.component';
import { CreateProductComponent } from 'app/dialogs/create-product/create-product.component';
import { CompanyService } from 'app/services/models/company.service';
import { KindService } from 'app/services/models/kind.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-sales-list',
  templateUrl: './sales-list.component.html',
  styleUrls: ['./sales-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SalesListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  kindId: number;
  public ColumnMode = ColumnMode;
  isSwitch = false;

  status: number = null;
  companyId: number = null;

  startFilterDate?: string | null = null;
  endFilterDate?: string | null = null;

  companies: any[];
  constructor(
    private transactionService: TransactionService,
    private kindService: KindService,
    private router: Router,
    private modalService: NgbModal,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
    private datePipe: DatePipe,
    private companyService: CompanyService) {
  }

  async ngOnInit() {

    await this.getByName('Satış');
    await this.getAllCompany();

    if (this.kindId != null) {
      await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
    }
  }

  async clearFilters() {
    this.companyId = null;
    this.status = null;
    this.fromDate = null;
    this.toDate = null;
    this.startFilterDate = null;
    this.endFilterDate = null;
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);

  }

  async getAllCompany() {
    const data = await this.companyService.getAllCompany('', 0, 10000);
    this.companies = data.companies.filter(p=>p.id != 1 && p.id != 2 && p.id != 3);
    console.log(this.companies);
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {
      await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
    }, 500);
  }

  async getByName(kindName: string) {
    const data = await this.kindService.getByName(kindName);
    console.log(data);
    this.kindId = data.id;
  }

  async onSwitchChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.isSwitch = isChecked;
    if (this.isSwitch) {
      this.status = 2;
    } else {
      this.status = null;
    }
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
  }

  async getAllOffer(page, size, seacrh, kindId, status, startDate, endDate, companyId) {
    this.blockUI.start('Satış yükleniyor...')
    try {
      const data = await this.transactionService.getAllOfferTransaction(page, size, seacrh, kindId, status, startDate, endDate, companyId);
      this.rows = data.transactionManagements;

      console.log(this.rows);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  async onPageChange(pageNumber: number) {
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {

      this.router.navigate([`/admin/sales-detail/${event.row.id}`]);
    }
  }

  async filterByStatus(event) {
    const filter = event.id;
    console.log(filter);
    this.status = filter
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
  }

  async filterByCompany(event) {
    const filter = event.id;
    console.log(filter);
    this.companyId = filter
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
  }

  statusList: any[] = [
    { id: 1, title: "Oluşturuldu." },
    { id: 2, title: "İptal Edildi." },
    { id: 3, title: "Onaylandı." },
    { id: 4, title: "Reddedildi" },
    { id: 5, title: "Taslak" },
    { id: 6, title: "Proforma" },
    { id: 7, title: "İrsaliye" },
    { id: 9, title: "Tamamlandı" }]

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Satış Oluşturuldu';
      case 2:
        return 'İptal Edildi';
      case 3:
        return 'Onaylandı';
      case 4:
        return 'Reddedildi';
      case 5:
        return 'Taslak';
      case 6:
        return 'Proforma';
      case 7:
        return 'İrsaliye';
      case 9:
        return 'Satış Tamamlandı'
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-glow badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-glow badge-danger';  // Danger class for status 2
      case 3:
        return 'badge badge-glow badge-success'; // Success class for status 3
      case 4:
        return 'badge badge-glow badge-warning'; // Warning class for status 4
      case 5:
        return 'badge badge-glow badge-info';
      case 6:
        return 'badge badge-glow badge-warning';
      case 7:
        return 'badge badge-glow badge-success';
      case 9:
        return 'badge badge-glow badge-success'
      default:
        return 'badge badge-glow badge-secondary'; // Secondary class for unknown status
    }
  }

  showCreateCompanyDialog() {
    this.modalService.open(CreateCompanyComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    })
  }

  showCreateProductDialog() {
    this.modalService.open(CreateProductComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    })
  }

  async onOptionDateChange() {
    // Tarih değiştiğinde yapılacak işlemler buraya
    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);
  }

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;


  /**
 * Range selection Date Picker
 *
 * @param date
 */
  async onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    const startDateFormatted = this.formatDate2(this.fromDate);
    const endDateFormatted = this.formatDate2(this.toDate);

    console.log('Start Date:', startDateFormatted ? startDateFormatted : 'Not selected');
    console.log('End Date:', endDateFormatted ? endDateFormatted : 'Not selected');

    this.startFilterDate = (startDateFormatted).toString();
    this.endFilterDate = (endDateFormatted).toString();

    await this.getAllOffer(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId, this.status, this.startFilterDate, this.endFilterDate, this.companyId);


  }

  formatDate2(date: NgbDate): string | null {
    if (!date) return null;

    // Convert NgbDate to JavaScript Date object
    const jsDate = new Date(date.year, date.month - 1, date.day);

    // Format the date using DatePipe
    return this.datePipe.transform(jsDate, 'yyyy-MM-dd');
  }

  /**
   * Is Hovered
   *
   * @param date
   */
  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  /**
   * Is Inside
   *
   * @param date
   */
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  /**
   *  Is Range
   *
   * @param date
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  displayDateRange(): string {
    if (this.fromDate && this.toDate) {
      return `${this.formatter.format(this.fromDate)} - ${this.formatter.format(this.toDate)}`;
    } else if (this.fromDate) {
      return this.formatter.format(this.fromDate);
    }
    return '';
  }
}
